export const COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME =
  "collection-preview-interactive"
